var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#close-x_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.606.455a1.516 1.516 0 0 1 1.972 0l5.418 5.387 5.311-5.31a1.516 1.516 0 0 1 2.213 2.06l-5.38 5.38 5.38 5.35a1.515 1.515 0 0 1 0 2.213 1.52 1.52 0 0 1-1.152.363 1.52 1.52 0 0 1-1.06-.439L7.98 10.132l-5.402 5.403a1.52 1.52 0 0 1-1.062.363 1.52 1.52 0 0 1-1.076-.363 1.516 1.516 0 0 1 0-2.137l5.403-5.403L.44 2.592A1.516 1.516 0 0 1 .606.455"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "close-x_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h16v16H0z"
})))));
export default SvgCloseX;